// test1447
(1447 && 0);
